export function safeExtraPropertiesSum (compute) {
  let sum = NaN
  try {
    sum = Number(compute())
  } catch (e) {
    console.error('extraPropertiesSum falló; se omite en el cierre', e)
    return null
  }
  return Number.isFinite(sum) ? sum.toFixed(2) : null
}

export function serializeExtraProperties (value) {
  if (value === null || value === undefined || value === '') {
    return null
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()
    return (trimmed === '' || trimmed === '[]' || trimmed === '{}') ? null : trimmed
  }

  if (Array.isArray(value)) {
    return value.length ? JSON.stringify(value) : null
  }

  if (typeof value === 'object') {
    return Object.keys(value).length ? JSON.stringify(value) : null
  }

  return null
}
